
export const passwordCriteria = {
    "8+ characters": {
        regex: /^.{8,}$/,
    },
    "At least 1 uppercase":{
        regex: /^(?=.*[A-Z])/,
    },
    "At least 1 lowercase ": {
        regex: /^(?=.*[a-z])/,
    },
    "At least 1 number ": {
        regex: /\d/,
    },
    "At least 1 special character\n!@#$%^&*:./?=+-_[]{}()<>": {
        regex: /[!@#$%^&*()\-_+=\[\]{}|\\\/:;"'<>,.?~`¬¢£€¥§©®™°µ×÷]/,
    },
};


